import {
  fetchElement,
  fetchElementById
} from '@client/core/utils/dom/domUtils';
import { PlacementId } from '@schibsted-nmp/advertising-shared';

const FILTER_LIST_ID = 'advertising--filters-bottom-marker';
const MARGIN = 100;

const fetchFilterListElement = () => fetchElementById(FILTER_LIST_ID);

export const isMiddleBannerOverlappingFilters = (placementId: PlacementId) => {
  if (!placementId.startsWith('advt_middle_')) return false;

  const filterListElement = fetchFilterListElement();
  const middleElement = fetchElement(
    `advt-component[placementid="${placementId}"]`
  );

  if (!filterListElement || !middleElement) return false;

  const filterBottomPlacement =
    filterListElement.getBoundingClientRect().bottom + window.scrollY + MARGIN;

  const middle1PlacementTop =
    middleElement.getBoundingClientRect().top + window.scrollY;

  return middle1PlacementTop < filterBottomPlacement;
};
